import { useRef, useEffect, useCallback } from 'react';
import { isBrowserHoverCapable } from '../../utils/browser';

const OPEN_DROPDOWN_TIMEOUT = 100;

export function useDropdownHover({
  isDropdownOpen,
  openDropdown,
  closeDropdown,
}: {
  isDropdownOpen: boolean;
  openDropdown: () => void;
  closeDropdown: () => void;
}) {
  const canHover = isBrowserHoverCapable();
  const openDropdownTimerId = useRef<any>(undefined);
  const closeDropdownTimerId = useRef<any>(undefined);

  const handleDropdownHover = useCallback(() => {
    if (!canHover) {
      return;
    }

    openDropdownTimerId.current = setTimeout(openDropdown, OPEN_DROPDOWN_TIMEOUT);
    clearTimeout(closeDropdownTimerId.current);
  }, [canHover, openDropdown]);

  const handleDropdownLeave = useCallback(() => {
    if (!canHover) {
      return;
    }

    clearTimeout(openDropdownTimerId.current);
    closeDropdown();
  }, [canHover, closeDropdown]);

  const handleDropdownTouch = useCallback(
    e => {
      if (!isDropdownOpen) {
        // default actions should only be prevented for the initial click
        // once the notification menu is shown, we want to let other touch
        // events pass through
        e.preventDefault();
      }
      handleDropdownHover();
    },
    [handleDropdownHover, isDropdownOpen]
  );

  useEffect(() => {
    return () => {
      clearTimeout(openDropdownTimerId.current);
      // TODO: I'm not entirely sure why the linter hates this particular line...
      // eslint-disable-next-line react-hooks/exhaustive-deps
      clearTimeout(closeDropdownTimerId.current);
    };
  }, []);

  return {
    handleDropdownHover,
    handleDropdownLeave,
    handleDropdownTouch,
  };
}
